<div class="d-flex flex-column justify-content-center align-items-center modal-product" style="padding:30px 10px;">
    <form [formGroup]="editForm" (ngSubmit)="onSubmit()">

        <div class="dialog-title">
            <h2>Edytuj</h2>
            <button mat-icon-button aria-label="close dialog" mat-dialog-close tabindex="-1"
                style="position:absolute; top:0; right:0;">
                <mat-icon>close</mat-icon>
            </button>
        </div>
        <mat-dialog-content class="w-100">
            <input type="hidden" formControlName="id">
            <div class="d-flex flex-row p-2">
                <div class="d-flex flex-column justify-content-between w-100 p-2">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Email</mat-label>
                        <input matInput type="text" name="email" formControlName="email">
                    </mat-form-field>
                    <div class="row" style="margin-top:15px;">
                        <div class="col-4">
                            <mat-slide-toggle class="example-margin" name="report" [checked]="currentAccount.report"
                            formControlName="report">
                                Report
                            </mat-slide-toggle>
                        </div>
                        <div class="col-4">
                            <mat-slide-toggle class="example-margin" name="error" [checked]="currentAccount.error"
                            formControlName="error">
                                Error
                            </mat-slide-toggle>
                        </div>
                        <div class="col-4">
                            <mat-slide-toggle class="example-margin" name="_alert" [checked]="currentAccount.alert"
                            formControlName="alert">
                                Alert
                            </mat-slide-toggle>
                        </div>
                    </div>
                </div>
            </div>
        </mat-dialog-content>
        <mat-dialog-actions class="d-flex flex-row justify-content-between w-100 p-2">
            <button mat-flat-button color="warn" mat-dialog-close class="w-b">Anuluj</button>
            <button mat-flat-button color="accent" type="submit" [disabled]="checkDisabled()" class="w-b">{{
                getSaveText() }}</button>
        </mat-dialog-actions>
</form>
</div>